var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{staticClass:"text-center",attrs:{"prominent":"","type":"error","elevation":"2"}},[_c('h2',[_vm._v(_vm._s(_vm.$t(`orders.${ _vm.isExpired ? 'orderExpired' : 'orderCanceledByMarketplace' }`)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }